// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invitees-list-item__displayname[data-v-e4bd912c]{margin-bottom:13px}.invitees-list-item__organizer-hint[data-v-e4bd912c]{margin-bottom:14px}", ""]);
// Exports
module.exports = exports;
